import { ApolloClient } from '@apollo/client';

import {
  GET_LESSON_TEACHING_LEARNING_SEQUENCE,
  teachingAndLearningSequenceFragment,
} from './teaching-notes.graphql';
import type { TeachingLearningSequenceFragment } from './teaching-notes.graphql.generated';
import { ActivitiesContentType } from 'global/constants';
import type {
  GetAssessmentTeachingAndLearningSequenceQuery,
  GetAssessmentTeachingAndLearningSequenceQueryVariables,
} from '../../assessment/teaching-notes/teaching-notes.graphql.generated';
import { GET_ASSESSMENT_TEACHING_LEARNING_SEQUENCE } from 'approot/activity-builder/assessment/teaching-notes/teaching-notes.graphql';
import type {
  GetLessonTeachingAndLearningSequenceQuery,
  GetLessonTeachingAndLearningSequenceQueryVariables,
} from './teaching-notes.graphql.generated';

export function getNoteFromCache(client: ApolloClient<any>, id: string) {
  return client.readFragment<TeachingLearningSequenceFragment>({
    id: client.cache.identify({
      __typename: 'ActivitiesTeachingLearningSequenceItem',
      id,
    }),
    fragment: teachingAndLearningSequenceFragment,
    fragmentName: 'TeachingLearningSequenceFragment',
  });
}

export function updateNoteInCache({
  client,
  note,
}: {
  client: ApolloClient<any>;
  note: TeachingLearningSequenceFragment;
}) {
  client.writeFragment<TeachingLearningSequenceFragment>({
    id: client.cache.identify({
      __typename: note.__typename,
      id: note.id,
    }),
    fragment: teachingAndLearningSequenceFragment,
    fragmentName: 'TeachingLearningSequenceFragment',
    data: note,
  });
}

export function updateSequencesInCache({
  client,
  contentId,
  contentType,
  classId,
  sequences,
}: {
  client: ApolloClient<any>;
  contentId: number;
  contentType: ActivitiesContentType;
  classId: number;
  sequences: TeachingLearningSequenceFragment[] | null;
}) {
  if (contentType === 'lesson-activities') {
    client.cache.writeQuery<
      GetLessonTeachingAndLearningSequenceQuery,
      GetLessonTeachingAndLearningSequenceQueryVariables
    >({
      data: {
        getLessonTeachingAndLearningSequence: sequences,
      },
      query: GET_LESSON_TEACHING_LEARNING_SEQUENCE,
      variables: {
        input: {
          contentId,
          classId,
          isDraft: true,
        },
      },
    });
  } else {
    client.cache.writeQuery<
      GetAssessmentTeachingAndLearningSequenceQuery,
      GetAssessmentTeachingAndLearningSequenceQueryVariables
    >({
      data: {
        getAssessmentTeachingAndLearningSequence: sequences,
      },
      query: GET_ASSESSMENT_TEACHING_LEARNING_SEQUENCE,
      variables: {
        input: {
          contentId,
          classId,
          isDraft: true,
        },
      },
    });
  }
}
